import React, { ReactNode } from "react"

import { useStyles } from "@/components/TopNavigation/components/RegionSelector/Dropdown/Options/Placeholder/Placeholder.styles"

const StartIcon = ({ className }) => (
    <svg
        className={className}
        width="24"
        height="18"
        viewBox="0 0 24 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.4 2.5998H19.2C19.53 2.5998 19.8 2.8698 19.8 3.1998V6.63481L20.0475 6.3873C20.4825 5.9523 21.0337 5.69355 21.6 5.61856V3.1998C21.6 1.87605 20.5237 0.799805 19.2 0.799805H2.4C1.07625 0.799805 0 1.87605 0 3.1998V12.7998C0 14.1236 1.07625 15.1998 2.4 15.1998H12.3937L12.6187 14.3036C12.7012 13.9736 12.8512 13.6661 13.0612 13.3998H2.4C2.07 13.3998 1.8 13.1298 1.8 12.7998V3.1998C1.8 2.8698 2.07 2.5998 2.4 2.5998ZM4.5 8.5998C4.00125 8.5998 3.6 9.00105 3.6 9.49981C3.6 9.99856 4.00125 10.3998 4.5 10.3998H12.3C12.7987 10.3998 13.2 9.99856 13.2 9.49981C13.2 9.00105 12.7987 8.5998 12.3 8.5998H4.5ZM3.6 5.89981C3.6 6.39855 4.00125 6.7998 4.5 6.7998H15.9C16.3987 6.7998 16.8 6.39855 16.8 5.89981C16.8 5.40105 16.3987 4.9998 15.9 4.9998H4.5C4.00125 4.9998 3.6 5.40105 3.6 5.89981ZM23.0175 7.23855C22.4325 6.65355 21.4837 6.65355 20.895 7.23855L19.7925 8.34106L22.455 11.0036L23.5575 9.90106C24.1425 9.31606 24.1425 8.36731 23.5575 7.77856L23.0175 7.23855ZM14.0962 14.0373C13.9425 14.1911 13.8337 14.3823 13.7812 14.5961L13.2187 16.8498C13.1662 17.0561 13.2262 17.2698 13.3762 17.4198C13.5262 17.5698 13.74 17.6298 13.9462 17.5773L16.2 17.0148C16.41 16.9623 16.605 16.8536 16.7587 16.6998L21.6037 11.8511L18.9412 9.18856L14.0962 14.0373Z"
            fill="#7259EF"
        />
    </svg>
)

const EmptyIcon = ({ className }) => (
    <svg
        className={className}
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.7292 17C7.55737 17 4.22925 13.6719 4.22925 9.5C4.22925 5.375 7.55737 2 11.7292 2C15.8542 2 19.2292 5.375 19.2292 9.5C19.2292 13.6719 15.8542 17 11.7292 17ZM11.7292 4.25C8.823 4.25 6.47925 6.64062 6.47925 9.5C6.47925 12.4062 8.823 14.75 11.7292 14.75C14.5886 14.75 16.9792 12.4062 16.9792 9.5C16.9792 6.64062 14.5886 4.25 11.7292 4.25ZM18.2917 22.25C19.2292 22.25 19.9792 23.0469 19.9792 23.9375C19.9792 24.2656 19.698 24.5 19.4167 24.5H5.54175C5.21362 24.5 4.97925 24.2656 4.97925 23.9375C4.97925 23.0469 5.72925 22.25 6.66675 22.25H11.3542V20.75C9.10425 20.6562 6.90112 19.9531 5.02612 18.5469L3.7605 19.8125C3.47925 20.0938 3.0105 20.0938 2.72925 19.8125L2.16675 19.2969C1.8855 18.9688 1.8855 18.5 2.16675 18.2188L4.93237 15.4531C5.073 15.5938 5.21362 15.7344 5.35425 15.875C7.04175 17.6094 9.29175 18.5 11.7292 18.5C14.1199 18.5 16.3699 17.6094 18.0574 15.875C19.7917 14.1875 20.7292 11.9375 20.7292 9.5C20.7292 7.10938 19.7917 4.85938 18.0574 3.17188C17.9167 3.03125 17.7761 2.89062 17.6355 2.75L19.6511 0.734375C19.9324 0.453125 20.4011 0.453125 20.7292 0.734375L21.2449 1.25C21.5261 1.57812 21.5261 2.04688 21.2449 2.32812L20.7292 2.84375C24.0105 7.25 23.6824 13.4844 19.6511 17.4688C17.9636 19.2031 15.8074 20.2344 13.6042 20.6094V22.25H18.2917Z"
            fill="#7259EF"
        />
    </svg>
)

export const Placeholder = ({
    actions,
    description,
    heading,
    renderIcon = (className) => <EmptyIcon className={className} />,
}: {
    actions?: ReactNode
    description?: string
    heading?: string
    renderIcon?: (className: string) => ReactNode
}) => {
    const { classes } = useStyles()

    return (
        <div className={classes.wrapper}>
            <div className={classes.iconWrapper}>{renderIcon(classes.icon)}</div>

            <div className={classes.content}>
                <h2 className={classes.heading}>{heading}</h2>
                <p className={classes.description}>{description}</p>
            </div>

            {actions}
        </div>
    )
}

Placeholder.StartIcon = StartIcon
Placeholder.EmptyIcon = EmptyIcon
